import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MemberService } from '../shared/services/member.service';
import Swal from 'sweetalert2';
import { WhiteSpaceValidator } from '../shared/validators/white-space-validator';
import { param } from 'jquery';
import { MatPaginator } from '@angular/material/paginator';
declare var $: any;
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {
   @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  searchKey:string='';
  selectedType='';
  heading='Insert';
  footer='Add';
  catagoryDropDown: any[];
  subCatagoryDropDown:any[]=[];
  isPresent: boolean=false;
  subcategoryDropDowns: any[];
  subCatagoryDropDowns: any;
  dataSource: MatTableDataSource<any>;
  supportform:FormGroup;
  submitControl=false;
  supporSubmitted=false;
  isusersubmitted=true;
  formheading:string='';
  pageNo:number=0;
  PageSize:Number;
  pagenationLength:number=30;
  users: any[]=[];
  token: string;
  textvalue:string;
  supportList:any[];
  visible:boolean;
  displayedColumns: string[] = [
    "firstName",
    "lastName",
    "email",
    "status",
    "designation",
    "TypeOfMember",
    "Category/Sub Category",
    "Actions",
    
    
  ];
  memberId: any;
  supportId: any;
  
  constructor(private spinnerService: NgxSpinnerService, private memberService: MemberService, private formBuilder: FormBuilder, private router: Router) {
    // this.spinnerService.show();
  }
 


  ngOnInit(): void {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    this.token = "Bearer" + " " + user.jwtToken;
    // this.organizationName = user.organaisationName;
    // this.orgId=user.organaisationId;
    this.spinnerService.show();
    this.getSupportList();
    this.getCatogoryList();
    this.supportform = this.formBuilder.group({
      firstName: [
        '', 
        [
          Validators.required,
          WhiteSpaceValidator, // Custom validator for whitespace
          Validators.pattern(/^(?=.*[a-zA-Z].*[a-zA-Z])[a-zA-Z\s]{3,}$/) // At least 2 letters and total 3+ chars
        ]
      ],
      lastName: [
        '', 
        [
          WhiteSpaceValidator,
          Validators.required,
          Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z\s]*$/) // At least 1 letter; allows spaces
        ]
      ],
     
      email: [
        '', 
        [
          Validators.required,
          WhiteSpaceValidator,
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) // Standard email format
        ]
      ],
      designation: [
        '', 
        [
          WhiteSpaceValidator,
          Validators.required,
          Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z\s]*$/) // At least 1 letter; allows spaces
        ]
      ],
      parentCategoryId:[
        '',
        [
          Validators.required
        ]
      ],
      subCategoryId:[
        '',
        [
          Validators.required
        ]
      ]
    });
  }
  getCatogoryList(){
    this.memberService
    .getCatogoryList( this.token)
    .subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.catagoryDropDown=data.categoryLists;
          this.catagoryDropDown=this.catagoryDropDown.map(value=>({
            categoryName:value.categoryName,
            categoryId:parseInt(value.categoryId),
          })
          )
          .filter(value=>value.categoryName!='General');
        
          this.subCatagoryDropDowns = data.categoryLists.map((value=>value.subCategoryList));
          
          this.subCatagoryDropDowns = data.categoryLists
          .map(value => value.subCategoryList) // Extract subCategoryList arrays
          .flat() // Flatten the array of arrays into a single array
          .map(value => ({
            categoryName: value.categoryName,
            categoryId: parseInt(value.categoryId),
            parentCategoryId: parseInt(value.parentCategoryId)
          })); 
          
        
        console.log('usb',this.subCatagoryDropDowns)

          // this.groupList= data.vendorGroupList.map(group => ({
          //   id: group.groupId,
          //   name: group.name,
          // }));
         console.log('data -------> ',this.catagoryDropDown);
          return;
        }
      },
      err => {
        if (err.status === 401) {
          this.unauthorizedException();
        }
      }
    );
  }
  get supportControl() {
    return this.supportform.controls;
  }

  oncatogorySelect(event:any){
    let subcatogoryList=  this.subCatagoryDropDown;
    this.isPresent=false;
    console.log('s',this.subCatagoryDropDowns);
    console.log('Event',(event.target as HTMLSelectElement).value);
    console.log('Subcatogory',this.subCatagoryDropDown);
    this.subCatagoryDropDown=  this.subCatagoryDropDowns.filter(
    (x) => x.parentCategoryId == (event.target as HTMLSelectElement).value
    );
    subcatogoryList=this.subcategoryDropDowns;
    // subcatogoryList=this.subCatagoryDropDown;
    
    console.log('subcatogory',this.subCatagoryDropDown);
    this.isPresent=  this.subCatagoryDropDown.length==0?false:true;
  }
 activeMemberSubmit() {
   console.log('Text value ',this.textvalue);
    this.isusersubmitted = true;
    if (this.isEmpty()) {
      return;
    }
    this.isusersubmitted = false;
    
    $("#suspendModel").modal("hide");
    Swal.fire({
      title: "Activate User",
      text: "Are you sure? Do you want to activate User?",
      icon: "warning",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm",
      allowOutsideClick: false
    }).then(result => {
      if (result.value) {
        // $("#progressModel").modal("show");
        this.spinnerService.show();
        this.memberService
        .postSupportStatus({ memberId: this.memberId, status: 1, reason: this.textvalue }, this.token)
        .subscribe(
          (data: { statusCode: Number; statusMessage: string }) => {
            if (data.statusCode === 200) {
             console.log('UserActive Or not', this.users);
              this.dataSource = new MatTableDataSource(this.users);
              this.dataSource.paginator = this.paginator;
              //this.spinnerService.hide();
              this.spinnerService.hide();
              
              Swal.fire({
                title: "Activated!",
                text: "User  is Activated now",
                icon: "success",
                showCloseButton: true,
                allowOutsideClick: false
              }).then(() => {
                $("#suspendModel").modal("hide");
                this.ngOnInit()
              });
              return;
            }
            else {
              $("#suspendModel").modal("hide");
              Swal.fire({
                title: data.statusMessage,
                icon: "warning",
                showCloseButton: true,
                allowOutsideClick: false
              });
              this.spinnerService.hide();
            }
          },
          err => {
            if (err.status === 401) {
              this.unauthorizedException();
              //this.spinnerService.hide();
            }
          }
        );

        
      }
    });
  }
// SuspendMemberSubmit(){}
isEmpty(){
return this.textvalue==''?true:false;
}
activateUser(member: any) {
  this.textvalue = '';
  this.isusersubmitted = false;
  this.visible = false;
  // this.member = null;
  this.memberId=member.supportId;
  this.formheading = "Activate User"
  $("#suspendModel").modal("show");
  // this.member = member;

}
SuspendHide(){
  $("#suspendModel").modal("hide");
}
changeStatus(element:any){
  if(element.typeOfMember!='Assigner'){
  Swal.fire({
    title: "Assign help desk admin",
    text: "Are you sure? Do you assign this technician as help desk admin?",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Confirm",
    allowOutsideClick: false
  }).then(result => {
    if (result.value) {
      console.log('reason', this.textvalue);
      // $("#progressModel").modal("show");
      
      $("#suspendModel").modal("hide");
      this.spinnerService.hide();
      let params={
        "technicianId":element.supportId,
        "categoryId": element.parentCategoryId
      }
      this.memberService
        .PostAdminAddSupportAssigner(params, this.token)
        .subscribe(
          (data: { statusCode: Number; statusMessage: string }) => {
            if (data.statusCode === 200) {
            //  console.log('UserActive Or not', this.users);
              // this.dataSource = new MatTableDataSource(this.users);
              // this.dataSource.paginator = this.paginator;
              this.spinnerService.hide();
              Swal.fire({
                title: "Assigned!",
                text: data.statusMessage,
                icon: "success",
                showCloseButton: true,
                allowOutsideClick: false
              }).then(() => {
                this.ngOnInit()
              });
              return;
            }
            else {
              this.spinnerService.hide();
              // $("#suspendModel").modal("hide");
              Swal.fire({
                title: data.statusMessage,
                icon: "warning",
                showCloseButton: true,
                allowOutsideClick: false
              });
            }
          },
          err => {
            if (err.status === 401) {
              this.unauthorizedException();
              //this.spinnerService.hide();
            }
          }
        );
    }
  });
}
else{
  Swal.fire({
    title: "Revoke help desk admin",
    text: "Are you sure? Do you want to revoke this technician's help desk admin role?",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonColor: "#d33", // Red for revoking
    cancelButtonColor: "#3085d6", // Blue for cancel
    confirmButtonText: "Revoke",
    allowOutsideClick: false
}).then(result => {
    if (result.value) {
        // console.log('reason', this.textvalue);

        // Hide modal or progress spinner if applicable
        // $("#suspendModel").modal("hide");
        this.spinnerService.hide();

        let params = {
            "technicianId": element.supportId,
            "categoryId": element.parentCategoryId
        };

        this.memberService
            .PostAdminAddSupportAssigner(params, this.token)
            .subscribe(
                (data: { statusCode: Number; statusMessage: string }) => {
                    if (data.statusCode === 200) {
                        this.spinnerService.hide();
                        Swal.fire({
                            title: "Revoked!",
                            text: data.statusMessage,
                            icon: "success",
                            showCloseButton: true,
                            allowOutsideClick: false
                        }).then(() => {
                            this.ngOnInit();  // Reload or refresh the data
                        });
                        return;
                    } else {
                        this.spinnerService.hide();
                        Swal.fire({
                            title: data.statusMessage,
                            icon: "warning",
                            showCloseButton: true,
                            allowOutsideClick: false
                        });
                    }
                },
                err => {
                    if (err.status === 401) {
                        this.unauthorizedException();
                        // this.spinnerService.hide();
                    }
                }
            );
    }
});

}
}
suspendUser(member: any) {
  this.memberId=member.supportId;
  this.textvalue = '';
  this.visible = true;
  this.isusersubmitted = false;
  this.formheading = "Suspend User"
  $("#suspendModel").modal("show");

}
 SuspendMemberSubmit() {
  console.log('Text value ',this.textvalue);
    this.isusersubmitted = true;
    if (this.isEmpty()) {
      return;

    }
    this.isusersubmitted = false;
    $("#suspendModel").modal("hide");
    Swal.fire({
      title: "Suspend User",
      text: "Are you sure? Do you want to suspend the User?",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm",
      allowOutsideClick: false
    }).then(result => {
      if (result.value) {
        console.log('reason', this.textvalue);
        // $("#progressModel").modal("show");
        
        $("#suspendModel").modal("hide");
        this.spinnerService.hide();
        this.memberService
          .postSupportStatus({ memberId: this.memberId, status: 0, reason: this.textvalue }, this.token)
          .subscribe(
            (data: { statusCode: Number; statusMessage: string }) => {
              if (data.statusCode === 200) {
               console.log('UserActive Or not', this.users);
                this.dataSource = new MatTableDataSource(this.users);
                this.dataSource.paginator = this.paginator;
                this.spinnerService.hide();
                Swal.fire({
                  title: "Suspended!",
                  text: "User  is suspended now",
                  icon: "success",
                  showCloseButton: true,
                  allowOutsideClick: false
                }).then(() => {
                  this.ngOnInit()
                });
                return;
              }
              else {
                this.spinnerService.hide();
                $("#suspendModel").modal("hide");
                Swal.fire({
                  title: data.statusMessage,
                  icon: "warning",
                  showCloseButton: true,
                  allowOutsideClick: false
                });
              }
            },
            err => {
              if (err.status === 401) {
                this.unauthorizedException();
                //this.spinnerService.hide();
              }
            }
          );
      }
    });



  }
getSupportList(){
 
  //   {
  //     "firstName": "John",
  //     "lastName": "Doe",
  //     "email": "john.doe@example.com",
  //     "designation": "Software Engineer",
  //     "supportId": 1,
  //     "isActive": 1,
  //     "isDeleted": 0
  //   },
  //   {
  //     "firstName": "Jane",
  //     "lastName": "Smith",
  //     "email": "jane.smith@example.com",
  //     "designation": "Project Manager",
  //     "supportId": 2,
  //     "isActive": 1,
  //     "isDeleted": 0
  //   },
  //   {
  //     "firstName": "Robert",
  //     "lastName": "Brown",
  //     "email": "robert.brown@example.com",
  //     "designation": "UX Designer",
  //     "supportId": 3,
  //     "isActive": 0,
  //     "isDeleted": 0
  //   },
  //   {
  //     "firstName": "Emily",
  //     "lastName": "Davis",
  //     "email": "emily.davis@example.com",
  //     "designation": "Quality Analyst",
  //     "supportId": 4,
  //     "isActive": 1,
  //     "isDeleted": 1
  //   },
  //   {
  //     "firstName": "Michael",
  //     "lastName": "Wilson",
  //     "email": "michael.wilson@example.com",
  //     "designation": "DevOps Engineer",
  //     "supportId": 5,
  //     "isActive": 0,
  //     "isDeleted": 1
  //   },
  //   {
  //     "firstName": "Sarah",
  //     "lastName": "Taylor",
  //     "email": "sarah.taylor@example.com",
  //     "designation": "Business Analyst",
  //     "supportId": 6,
  //     "isActive": 1,
  //     "isDeleted": 0
  //   }
  // ];
  
  // this.supportList=sampleData;
  // this.dataSource = new MatTableDataSource(sampleData);
  
    //  this.dataSourceAnnouncement= new MatTableDataSource(sampleData);
     
      // this.spinnerService.show();
      // let params={
      //   "roleId": 0,
      //   "pageNo": 1,
      //   "pageSize": 5
      // }
     
      // return;
      this.spinnerService.show();
      this.memberService.SupportHelpdeskList(this.token).subscribe(
        (data: any) => {
          // this.ishubspotLoading = false;
          if (data.statusCode == 200) {
            console.log(data.statusCode)
            // setTimeout(() => {
            // 
            // }, 800)
            this.spinnerService.hide();
            // let userData = this.getMemberListArray(data.memberList);
            // this.users = data.announcementList;
            // console.log('Users', this.users);
            this.users=data.supportList;
            this.dataSource = new MatTableDataSource(this.users);
            this.dataSource.paginator = this.paginator;
            // this.totalItems = data.filteredCount
            // this.dataSource.sort = this.sort;
            this.spinnerService.hide();
          }
          else {
           
            Swal.fire({
              title: data.statusMessage,
              icon: "warning",
              showCloseButton: true,
              allowOutsideClick: false
            });
            this.spinnerService.hide();
  
          }
        },
        err => {
          if (err.status === 401) {
            this.spinnerService.hide();
            this.unauthorizedException();
          }
        }
      );

}
onDeleteSubmit(row){
  // this.spinnerService.show();
  console.log('row',row.supportId);
  Swal.fire({
    title: "Delete Technician",
    text: "Are you sure you want to delete this Technician ",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Confirm",
    allowOutsideClick: false,
  }).then((result) => {
    if (result.value) {
      this.spinnerService.show();
   let params={
    "memberId":row.supportId
   };
   console.log(params);
      this.memberService
        .deleteMember(params, this.token) // Assuming `row.id` is the correct memberId
        .subscribe(
          (data: any) => {
            if(data.statusCode==200){
            this.spinnerService.hide();
            Swal.fire({
              title: "Deleted!",
              text: " Technician Member is deleted now",
              icon: "success",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then(() => {
              this.ngOnInit(); // Refresh data after deletion
            });
          }
          else{
            this.spinnerService.hide();
            Swal.fire({
              title: "Bad Request!",
              // text: "Bad Request",
              icon: "warning",
              showCloseButton: true,
              allowOutsideClick: false,
            })
          }
          },
          (err) => {
            this.spinnerService.hide();
            if (err.status === 401) {
              this.unauthorizedException();
            } else {
              Swal.fire({
                title: "Error!",
                text: "An error occurred while deleting the Vendor.",
                icon: "error",
                showCloseButton: true,
                allowOutsideClick: false,
              });
            }
          }
        );
    }
  });
  }
// activateUser(row){
//    Swal.fire({
//      title: "Activate Vendor Group",
//      text: "Are you sure? Do you want to Vendor Group?",
//      icon: "warning",
//      showCloseButton: true,
//      showCancelButton: true,
//      confirmButtonColor: "#3085d6",
//      cancelButtonColor: "#d33",
//      confirmButtonText: "Confirm",
//      allowOutsideClick: false
//    }).then(result => {
//      if (result.value) {
//        // $("#progressModel").modal("show");
//        this.spinnerService.show();
//        let params={
//          "groupId": row.groupId,
//          "isActive":row.isActive
//        }
//        this.memberService
//          .postSupportStatus(params, this.token)
//          .subscribe(
//            (data: any) => {
//              this.spinnerService.hide();
//              if (data.statusCode === 200) {
//               Swal.fire({
//                  title: "Activated!",
//                  text: "Support Member is active now",
//                  icon: "success",
//                  showCloseButton: true,
//                  allowOutsideClick: false
//                });
//                this.ngOnInit();
//              }
//              else {
//                this.spinnerService.hide();
//                Swal.fire({
//                  title: data.statusMessage,
//                  icon: "warning",
//                  showCloseButton: true,
//                  allowOutsideClick: false
//                });
//              }
//            },
//            err => {
//              if (err.status === 401) {
//                this.unauthorizedException();
//                this.spinnerService.hide();
//              }
//            }
//          );
//      }
//    });
//  }
 onOpenSupportInsert(){
  this.supporSubmitted = false;
  this.heading="Add Technician";
  this.footer="Add";
  this.isPresent=false;
  this.submitControl=true;
  $("#newSupportCreate").modal("show");
  this.supportform = this.formBuilder.group({
    firstName: [
      '', 
      [
        Validators.required,
        WhiteSpaceValidator, // Custom validator for whitespace
        Validators.pattern(/^(?=.*[a-zA-Z].*[a-zA-Z])[a-zA-Z\s]{3,}$/) // At least 2 letters and total 3+ chars
      ]
    ],
    lastName: [
      '', 
      [
        WhiteSpaceValidator,
        Validators.required,
        Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z\s]*$/) // At least 1 letter; allows spaces
      ]
    ],
   
    email: [
      '', 
      [
        Validators.required,
        WhiteSpaceValidator,
        Validators.pattern(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) // Standard email format
      ]
    ],
    designation: [
      '', 
      [
        WhiteSpaceValidator,
        Validators.required,
        Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z\s]*$/) // At least 1 letter; allows spaces
      ]
    ],
    parentCategoryId:[
      0,
      [
        Validators.required
      ]
    ],
    subCategoryId:[
      0,
      [
        Validators.required
      ]
    ]
  });
  

}
onClickUpdate(row:any){
  $("#newSupportCreate").modal("show");
  this.supportId=row.supportId
  this.heading='Update Technician';
  this.footer='Update';
  this.submitControl=false;
  this.supportform = this.formBuilder.group({
    firstName: [
      row.firstName, 
      [
        Validators.required,
        WhiteSpaceValidator, // Custom validator for whitespace
        Validators.pattern(/^(?=.*[a-zA-Z].*[a-zA-Z])[a-zA-Z\s]{3,}$/) // At least 2 letters and total 3+ chars
      ]
    ],
    lastName: [
      row.lastName, 
      [
        WhiteSpaceValidator,
        Validators.required,
        Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z\s]*$/) // At least 1 letter; allows spaces
      ]
    ],
   
    email: [
      row.email, 
      [
        Validators.required,
        WhiteSpaceValidator,
        Validators.pattern(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) // Standard email format
      ]
    ],
    designation: [
      row.designation, 
      [
        WhiteSpaceValidator,
        Validators.required,
        Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z\s]*$/) // At least 1 letter; allows spaces
      ]
    ],
    parentCategoryId:[
      row.parentCategoryId,
      [
        Validators.required
      ]
    ],
    subCategoryId:[
      row.subCategoryId,
      [
        Validators.required
      ]
    ]
  });
}
//  suspendUser(row){
//     Swal.fire({
//       title: "Inactivate Support Member",
//       text: "Are you sure? Do you want to Inactivate Support Member?",
//       icon: "warning",
//       showCloseButton: true,
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Confirm",
//       allowOutsideClick: false
//     }).then(result => {
//       if (result.value) {
//         // $("#progressModel").modal("show");
//         this.spinnerService.show();
//         let params={
//           "groupId": row.groupId,
//           "isActive":row.isActive
//         }
//         this.memberService
//           .postSupportStatus(params, this.token)
//           .subscribe(
//             (data: any) => {
//               if (data.statusCode === 200) {
//                 this.spinnerService.hide();
//                Swal.fire({
//                   title: "Inactivated!",
//                   text: "Support Member is Inactive now",
//                   icon: "success",
//                   showCloseButton: true,
//                   allowOutsideClick: false
//                 });
//                 this.ngOnInit();
//               }
//               else {
//                 this.spinnerService.hide();
//                 Swal.fire({
//                   title: data.statusMessage,
//                   icon: "warning",
//                   showCloseButton: true,
//                   allowOutsideClick: false
//                 });
//               }
//             },
//             err => {
//               if (err.status === 401) {
//                 this.unauthorizedException();
//                 this.spinnerService.hide();
//               }
//             }
//           );
//       }
//     });
//   }
  SupportFormSubmit(){
    this.supporSubmitted = true;
        if (!this.supportform.valid){
          return;
        }
        
       this.spinnerService.show();
        this.supporSubmitted = false;
        let params=this.supportform.value;
        console.log(params);
        
        this.memberService.PostInsertSupport(params,this.token).subscribe(
          (data: any) => {
            
            // this.ishubspotLoading = false;
            if (data.statusCode == 201) {
              $("#newSupportCreate").modal("hide");
              Swal.fire({
                title: "Created!",
                text: "Technician created successfully",
                icon: "success",
                showCloseButton: true,
                allowOutsideClick: false
              });
              this.spinnerService.hide();
              this.ngOnInit();
             
            }
            else {
              // this.isLoading = false;
              Swal.fire({
                title: data.statusMessage,
                icon: "warning",
                showCloseButton: true,
                allowOutsideClick: false
              });
              this.spinnerService.hide();
    
            }
          },
          err => {
            if (err.status === 401) {
              this.spinnerService.hide();
              this.unauthorizedException();
            }
          }
        );
  }
  SupportFormUpdateSubmit(){
    this.supporSubmitted = true;
      if (!this.supportform.valid){
        return;
      }
      this.supporSubmitted = false;
      this.spinnerService.show();
      
      // let params=this.supportform.value;
      let params={
        
          "supportId":this.supportId,
          "firstName":this.supportform.value.firstName,
          "lastName":this.supportform.value.lastName,
          "designation":this.supportform.value.designation,
          "email":this.supportform.value.email,
          "parentCategoryId":this.supportform.value.parentCategoryId,
          "subCategoryId":this.isPresent?this.supportform.value.subCategoryId:0,
      
      }
      console.log(params);
      
      this.memberService.postSupportUpdate(params,this.token).subscribe(
        (data: any) => {
        
          // this.ishubspotLoading = false;
          if (data.statusCode == 200) {
            $("#newSupportCreate").modal("hide");
            Swal.fire({
              title: "Updated!",
              text: "Technician Updated successfully",
              icon: "success",
              showCloseButton: true,
              allowOutsideClick: false
            });
            // this.selectedType="0";
            
            // this.GetVendorList(1,10,'',0);
            // this.ngOnInit();
            this.spinnerService.hide();
           this.ngOnInit();
          }
          else {
            // this.isLoading = false;
            Swal.fire({
              title: data.statusMessage,
              icon: "warning",
              showCloseButton: true,
              allowOutsideClick: false
            });
            this.spinnerService.hide();
    
          }
        },
        err => {
          if (err.status === 401) {
            this.spinnerService.hide();
            this.unauthorizedException();
          }
        }
      );
    
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  checkAllFieldsEntered(): boolean {
    return Object.keys(this.supportform.controls).every(controlName => {
     
       if(controlName=='parentCategoryId' && !this.isPresent ){
        const control = this.supportform.get(controlName);
        if(control.value==0){
          return false;
        }
        return true;
      }
      else if(controlName=='subCategoryId' && this.isPresent){
        const control = this.supportform.get(controlName);
        if(control.value==0){
          return false;
        }
        return true;
        }
       
      
      const control = this.supportform.get(controlName);
     
      return control.value !== '' && control.value !== null ;
    });
  }

unauthorizedException() {
      Swal.fire({
        icon: "warning",
        title: "Session Expired!",
        allowOutsideClick: false,
        confirmButtonColor: "#d33",
        confirmButtonText: "Logout"
      }).then(() => {
        localStorage.clear();
        this.router.navigate(["/login"]);
      });
      return;
    }
 hide(){
  this.supporSubmitted = false;
  this.isPresent=false;
    $("#newSupportCreate").modal("hide");
  }
  
  filterEvent(event:any){

  }
  onSelectChange(event:any){

  }

}
